import React, { useContext, useEffect, useState } from 'react';
import SideLeft from '../layout/SideLeft';
import StatAbonnement from '../components/StatAbonnement';
import MainLayout from '../layout/MainLayout';
import CenterLayout from '../layout/CenterLayout';
import StatProjects from '../components/StatProjects';
import StatProjectInfo from '../components/StatProjectInfo';
import StatSubscriber from '../components/StatSubscriber';
import AppContext from '../Context/AppContext';


const Homepage = () => {
    const [compCenter, setCompCenter] = useState(<StatProjectInfo label={"Empire Streaming"} targetUrl={"occurence_empire"} />)
    const { setCurrentPage, setSideSheetOpen } = useContext(AppContext)

    const openCenter = (cmp) => {
        setCompCenter(cmp)
        setSideSheetOpen(false) // ferme le bottom-sheet (mobile) pour voir le composant
    }

    useEffect(() => {
        setCurrentPage('homepage')
    }, [])
    return (
        <MainLayout>
            <CenterLayout>
                {compCenter}
            </CenterLayout>
            <SideLeft>
                {/**
                 * 
                 <p className='fm cw mb1 fs20'>Abonnements</p>
                 <StatAbonnement open={(cmp)=>setCompCenter(cmp)} />
                 * 
                 */}
                <StatProjects open={openCenter} />
                <p className='fm cw mb1 fs20'>Création de compte</p>
                <StatSubscriber open={openCenter} projectLabel="empirestreaming" />

            </SideLeft>
        </MainLayout>

    );
};

export default Homepage;